import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import '../styles/promo-banner.css';

// Banner configuration - update content here
const BANNER_CONFIG = {
  // Auto-expire date (banner stops showing after this date)
  expirationDate: '2099-12-31T23:59:59',
  
  // localStorage key for dismissal
  storageKey: 'gcf-promo-banner-dismissed-bungee-bogo',
  
  // Banner content
  emoji: '🎉',
  headline: 'First time flying? BOGO',
  details: 'Two Bungee 101 classes for $35',
  buttonText: 'Claim Your BOGO',
  buttonLink: '/book-bungee'
};

const PromoBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const location = useLocation();

  // Pages where the promo banner should stay hidden
  const hiddenPaths = ['/book-aerial'];

  useEffect(() => {
    // Check if banner has expired
    const now = new Date();
    const expirationDate = new Date(BANNER_CONFIG.expirationDate);
    
    if (now > expirationDate) {
      // Banner has expired, don't show
      return;
    }
    
    // Check if user has dismissed this banner
    const dismissed = localStorage.getItem(BANNER_CONFIG.storageKey);
    if (!dismissed) {
      setShowBanner(true);
    }
  }, []);

  const dismissBanner = () => {
    localStorage.setItem(BANNER_CONFIG.storageKey, 'true');
    setShowBanner(false);
  };

  if (!showBanner || hiddenPaths.some(p => location.pathname.startsWith(p))) return null;

  return (
    <div className="promo-banner" data-testid="promo-banner">
      <button 
        className="promo-banner-close" 
        onClick={dismissBanner} 
        aria-label="Dismiss banner"
        data-testid="promo-banner-close"
      >
        <X size={16} />
      </button>
      <a href={BANNER_CONFIG.buttonLink} className="promo-banner-link">
        <div className="promo-banner-content">
          <p className="promo-banner-text">
            <span className="promo-banner-emoji">{BANNER_CONFIG.emoji}</span>
            <span className="promo-banner-headline">{BANNER_CONFIG.headline}</span>
            <span className="promo-banner-details">{BANNER_CONFIG.details}</span>
          </p>
          <span className="promo-banner-btn">
            {BANNER_CONFIG.buttonText}
          </span>
        </div>
      </a>
    </div>
  );
};

export default PromoBanner;
